export default "__VITE_ASSET__DFsoIsNu__"